import { Component } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Component({
  selector: 'loader',
  templateUrl: 'loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  loading: HTMLIonLoadingElement;
  constructor(public loadingController: LoadingController) { }

  async presentLoading(message: string  = ''): Promise<void> {
    this.loading = await this.loadingController.create({
      cssClass: 'loader',
      message,
      mode: 'md',
    });
    await this.loading.present();
  }

  async dismiss() {
    await this.loading.dismiss();
  }
}
